import React from 'react';

// شعار الجمعية: `logo` القفل الكامل، و`mark` العلامة وحدها للمساحات الضيّقة.
// النسخة الملوّنة للخلفيات الفاتحة والبيضاء للداكنة. العرض يُحسب من الارتفاع
// حفاظاً على النِّسب.
export default function Logo({ kind = 'logo', variant = 'color', height = 44, className = '' }) {
  return (
    <img
      className={`logo ${className}`.trim()}
      src={`${process.env.PUBLIC_URL}/logo/hdat-${kind}-${variant}.png`}
      alt="جمعية هداة الخيرية"
      style={{ height, width: 'auto' }}
    />
  );
}
